<template>
<div class="chapter">
<div class="inner_page">
<div id="Contents">
<p class="toc-title">Table of Contents</p>
<p class="imaget"><img alt="image" src="images/star.jpg" width="4%"/></p>
<p class="toc"><a href="#/06_Chapter01">THE ELVES AND THE SHOEMAKER</a></p>
<p class="toc"><em class="italic">The Brothers Grimm • Germany</em></p>
<p class="toct"><a href="#/07_Chapter02">AFTER CHRISTMAS</a></p>
<p class="toc"><em class="italic">Hermann Hesse • Germany</em></p>
<p class="toct"><a href="#/08_Chapter03">BERLIN AT CHRISTMASTIDE</a></p>
<p class="toc"><em class="italic">Heinrich Heine • Germany</em></p>
<p class="toct"><a href="#/09_Chapter04">CHRISTMAS</a></p>
<p class="toc"><em class="italic">Kurt Tucholsky • Germany</em></p>
<p class="toct"><a href="#/10_Chapter05">INTERVIEW WITH SANTA CLAUS</a></p>
<p class="toc"><em class="italic">Erich Kästner • Germany</em></p>
<p class="toct"><span href="#/11_Chapter06" title="Link target outside of Sample">THE SEPARATION</span></p>
<p class="toc"><em class="italic">Ilse Frapan • Germany</em></p>
<p class="toct"><span href="#/12_Chapter07" title="Link target outside of Sample">EVERY YEAR ONCE AGAIN—THE CLIENT GIFT</span></p>
<p class="toc"><em class="italic">Martin Suter • Switzerland</em></p>
<p class="toct"><span href="#/13_Chapter08" title="Link target outside of Sample">THE CHRISTMAS BOX</span></p>
<p class="toc"><em class="italic">Johann Wolfgang von Goethe • Germany</em></p>
<p class="toct"><span href="#/14_Chapter09" title="Link target outside of Sample">IN THE OUTER SUBURBS</span></p>
<p class="toc"><em class="italic">Peter Stamm • Switzerland</em></p>
<p class="toct"><span href="#/15_Chapter10" title="Link target outside of Sample">ADVENT</span></p>
<p class="toc"><em class="italic">Rainer Maria Rilke • Austria</em></p>
<p class="toct"><span href="#/16_Chapter11" title="Link target outside of Sample">CHRISTMAS SHOPPING</span></p>
<p class="toc"><em class="italic">Arthur Schnitzler • Austria</em></p>
<p class="toct"><span href="#/17_Chapter12" title="Link target outside of Sample">CHRISTMAS WITH THE BUDDENBROOKS</span></p>
<p class="toc"><em class="italic">Thomas Mann • Germany</em></p>
<p class="toct"><span href="#/18_Chapter13" title="Link target outside of Sample">CHRISTMAS NOT JUST ONCE A YEAR</span></p>
<p class="toc"><em class="italic">Heinrich Böll • Germany</em></p>
<p class="toct"><span href="#/19_Chapter14" title="Link target outside of Sample">ON CHRISTMAS EVE</span></p>
<p class="toc"><em class="italic">Helene Stökl • Germany</em></p>
<p class="toct"><span href="#/20_Chapter15" title="Link target outside of Sample">NUTCRACKER AND THE KING OF MICE</span></p>
<p class="toc"><em class="italic">E. T. A. Hoffmann • Germany</em></p>
<p class="toct"><span href="#/21_Chapter16" title="Link target outside of Sample">CHRISTMAS IN COCHINCHINA</span></p>
<p class="toc"><em class="italic">Joseph Roth • Austria</em></p>
<p class="toct"><span href="#/22_Chapter17" title="Link target outside of Sample">CHRISTMAS EVE</span></p>
<p class="toc"><em class="italic">Peter Rosegger • Austria</em></p>
<p class="toct"><span href="#/23_Chapter18" title="Link target outside of Sample">MARTIN’S CHRISTMAS WISH</span></p>
<p class="toc"><em class="italic">Erich Kästner • Germany</em></p>
<p class="toct"><span href="#/24_Chapter19" title="Link target outside of Sample">THE LOAN</span></p>
<p class="toc"><em class="italic">Wolfdietrich Schnurre • Germany</em></p>
<p class="toct"><span href="#/25_Chapter20" title="Link target outside of Sample">O TANNENBAUM</span></p>
<p class="toc"><em class="italic">Ernst Anschütz • Germany</em></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_Contents.vue?64261150